import './styles/index.sass';
import './styles/slick.scss';
import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import MainRouter from './components/main-router';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import { setupStore } from "~/store/store";
import { WhatsappWidget } from "~/components/whatsapp-widget";
import FooterUZ from "~/components/footer-uz";
import Footer from "~/components/footer";
const version = require('../package.json').version

const versionPbx = process.env.IS_BROWSER + '' === 'true' && window.localStorage.pbxVersion
if (process.env.IS_BROWSER + '' === 'true' && version && version != versionPbx) {
  window.localStorage.pbxVersion = version
  // @ts-ignore
    window.location.reload(true)
}


declare global {
  interface Window {
    SERVER_DATA?: any,
    yaCounter631388?: any,
    amplitude?: any
  }
}

const store = setupStore();

ReactDOM.render(
    <BrowserRouter>
      <Provider store={store}>
          <MainRouter />
      </Provider>
    </BrowserRouter>,
  document.getElementById('wrapper')
)
